<template>
  <div class="white-container full-page-container common-table">
    <div class="uaraTaskTitle">关联商品配置</div>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="搜索商品名称或SKU" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-if="searchList.length" ref="multipleTable" size="small" :data="searchList" style="width: 100%">
      <el-table-column prop="id" label="任务ID" />
      <el-table-column prop="sku" label="商品SKU编码" />
      <el-table-column prop="name" label="任务名称" />
      <el-table-column prop="equipmentTaskClockImageListVOList" label="当前商品">
        <template v-slot="{row}">
          <img :src="row.imageUrl" alt="" class="flexImg">
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleAdd(row)">添加</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="addGoods" :style="searchList.length?'margin: 50px 0 30px 0':'margin: 0px 0 30px 0'">已添加商品</div>
    <el-table ref="multipleTable" size="small" :data="addList" style="width: 100%">
      <el-table-column prop="id" label="任务ID" />
      <el-table-column prop="sku" label="商品SKU编码" />
      <el-table-column prop="name" label="任务名称" />
      <el-table-column prop="equipmentTaskClockImageListVOList" label="当前商品">
        <template v-slot="{row}">
          <img :src="row.imageUrl" alt="" class="flexImg">
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex btns">
      <el-button type="info" @click="cancelBtn">取消</el-button>
      <el-button type="primary" @click="submit">保存并应用</el-button>
    </div>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>

<script>
import Dialog from '@/components/Dialog';
export default {
  components: { Dialog },
  data() {
    return {
      search: {
        name: "",
      },
      searchList: [],
      addList: [],
      formDialogShow: false,
      information: {},
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    getTableList() {
      this.$Api.uaraTask.getUaraTableList().then(res => {
        this.addList = res;
      });
    },
    // 搜索
    searchSubmit() {
      if (/^\s*$/g.test(this.search.name)) return this.$message.warning('搜索框不可为空'); // 不能为空
      this.$Api.equipment.getEquipmentBySku(this.search.name).then(res => {
        if (res) {
          this.searchList = res;
        }
      });
    },
    // 重置
    reset() {
      this.search.name = '';
      this.searchList = [];
    },
    // 添加
    handleAdd(row) {
      const len = this.addList.filter(item => item.sku === row.sku);
      if (len.length) {
        this.$message.warning('请不要添加重复商品');
        return;
      }
      this.addList.push(row);
    },
    // 删除
    handleDelete(row) {
      this.addList = this.addList.filter(item => item.sku !== row.sku);
    },
    // 取消
    cancelBtn() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `您有未保存的商品配置，确认取消?`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.reset();
        this.getTableList();
      }
    },
    // 保存并使用
    submit() {
      const skus = this.addList.map(item => item.sku);
      this.$Api.uaraTask.saveUaraTableList({
        equipmentSkus: skus,
      }).then(res => {
        this.$message.success('保存成功');
        this.reset();
        this.getTableList();
      });
    },
  },
};
</script>

<style scoped>
.uaraTaskTitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: #494949;
  margin-bottom: 30px;
}
.addGoods {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #494949;
}
.btns {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
}
.flexImg {
  width: 75px;
  height: 75px;
}
</style>
